import { SetCurrentSeasons } from '@protector/entities/core/__legacy__/redux.actions';
import type { Season } from '@protector/entities/season/models';
import _ from 'lodash';
import { ofType, type ActionsObservable, type StateObservable } from 'redux-observable';
import type { AppState } from 'redux/app-state';
import { of } from 'rxjs';
import { concatMap, map, withLatestFrom } from 'rxjs/operators';
import { getSelectedProperty } from '../property/property.selectors';
import { LoadSeasonsSuccess, SeasonActionsTypes, type SetSeasonsFromProperties, type SetSeasonsFromProperty } from './season.actions';
import { getActiveSeasonsIdsOrMostRecent } from './season.functions';
import { selectAllSeasons } from './season.reducer';

export const handleSetSeasonsFromProperties = (action$: ActionsObservable<ReturnType<typeof SetSeasonsFromProperties>>) =>
  action$.pipe(
    ofType(SeasonActionsTypes.SET_SEASONS_FROM_PROPERTIES),
    map(action => action.payload),
    concatMap(properties => {
      const activeSeasons = properties.flatMap(p => p.seasons);
      return of(LoadSeasonsSuccess(_.uniqBy(activeSeasons, 'id')));
    })
  );

export const handleSetSeasonsFromProperty = (
  action$: ActionsObservable<ReturnType<typeof SetSeasonsFromProperty>>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType(SeasonActionsTypes.SET_SEASONS_FROM_PROPERTY),
    withLatestFrom(state$.pipe(map(state => getSelectedProperty(state)))),
    concatMap(([, selectedProperty]) => {
      let activeSeasons: Season[] = [];
      if (selectedProperty) {
        activeSeasons = selectedProperty.seasons;
      }
      return of(LoadSeasonsSuccess(activeSeasons));
    })
  );

export const selectActiveSeasonsAsActive = (
  action$: ActionsObservable<ReturnType<typeof LoadSeasonsSuccess>>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType(SeasonActionsTypes.LOAD_SEASONS_SUCCESS),
    map(action => action.payload),
    withLatestFrom(state$.pipe(map(state => selectAllSeasons(state.entities.season)))),
    concatMap(([, seasons]) => {
      const { seasonsID } = getActiveSeasonsIdsOrMostRecent(seasons);

      return of(SetCurrentSeasons(seasonsID));
    })
  );
